/**
 * @file Column component for displaying a datetime value and its deviation to a related datetime value.
 * @author Willem Jan Weitering
 */
import * as tslib_1 from "tslib";
import { OnInit, ChangeDetectorRef } from '@angular/core';
import { ColumnBase } from '../../base/columns/column-base/column-base';
import { ColumnProvider } from '../../base/column-provider';
import { LocalisationService } from '../../core/localisation.service';
import * as moment from 'moment';
import { ComponentRegistry } from '../../core/component-registry';
/**
 * Column component for displaying a datetime value and its deviation to a related datetime value.
 */
var ColumnDatetimeDeviationComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ColumnDatetimeDeviationComponent, _super);
    /**
     * Constructs a ColumnDatetimeDeviationComponent.
     * @param provider Provides the configuration information for the column.
     */
    function ColumnDatetimeDeviationComponent(provider, changeDetector, localisationService) {
        var _this = _super.call(this, provider, changeDetector) || this;
        _this.localisationService = localisationService;
        _this.showDeviation = true;
        _this.compareValue = undefined;
        return _this;
    }
    /**
     * Register this column class for the column provider.
     */
    ColumnDatetimeDeviationComponent.register = function () {
        ComponentRegistry.register('column', 'datetime-deviation', ColumnDatetimeDeviationComponent);
    };
    ColumnDatetimeDeviationComponent.prototype.ngOnInit = function () {
        this.setInitialValues();
    };
    Object.defineProperty(ColumnDatetimeDeviationComponent.prototype, "timeDeviation", {
        /* property with deviation info */
        get: function () {
            var timeDeviation = null;
            if (this.showDeviation) {
                // So what's the time deviation and make it human readable
                timeDeviation = this.compareValue.diff(moment(this.provider.value));
                var deviationSign = timeDeviation < 0 ? '+' : '-';
                if (timeDeviation !== 0) {
                    timeDeviation = deviationSign + moment.duration(timeDeviation).humanize();
                }
            }
            return timeDeviation;
        },
        enumerable: true,
        configurable: true
    });
    ColumnDatetimeDeviationComponent.prototype.setInitialValues = function () {
        // get format from configuration
        var compareFormat = this.provider.field.format;
        // Do we have to show deviation?
        if (compareFormat.deviationType === 'SpendTime') {
            var account = this.provider.entity['Account'];
            if (account) {
                if (account.entityType.shortName !== 'Assignment') {
                    this.showDeviation = false;
                }
            }
            else {
                this.showDeviation = false;
            }
        }
        if (this.showDeviation) {
            // Get value to compare with the base value
            var propertyParts = compareFormat.deviationFrom.split('.');
            var compareValue = this.provider.entity;
            // tslint:disable-next-line
            for (var item in propertyParts) {
                compareValue = compareValue[propertyParts[item]];
            }
            this.compareValue = moment(compareValue);
        }
    };
    return ColumnDatetimeDeviationComponent;
}(ColumnBase));
export { ColumnDatetimeDeviationComponent };
